import { createApi } from '../createApi';
import * as real from '../api/ota';

// dummy 데이터 미구현 — 현 단계 어드민 전용 페이지라 USE_DUMMY 모드에서 의미 없음.
// USE_DUMMY 활성화 시 createApi 가 real 폴백.
const dummy = {};

const api = createApi(dummy, real);

/** OTA 서비스 — Klook/Viator/Trip.com 채널 메타 + 동기화 로그 */
export const otaService = {
  adminListChannels: api.adminListOtaChannels,
  adminCreateChannel: api.adminCreateOtaChannel,
  adminUpdateChannel: api.adminUpdateOtaChannel,
  adminDeleteChannel: api.adminDeleteOtaChannel,
  adminListSyncLogs: api.adminListOtaSyncLogs,
};
